import { getColumnsByNames } from './all-top10-columns-config';

export const topUrlFilteringCategoriesAndDns = getColumnsByNames([
    { name: 'category', width: '35%' },
    { name: 'count', width: '62%' }
]);